/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

export * from './job-spec-template-rest.service';
export * from './job-spec-template.dto';
export * from './job-spec-template.mapper';
